import jwt from "jsonwebtoken"; // Pastikan Anda telah menginstall 'jsonwebtoken'
import querystring from "querystring"; // Pastikan Anda telah menginstall 'querystring'
import { createStore } from "redux";
import authreducers from "../store/reducer/auth";
import { logout } from "../store/action/auth"; // Pastikan path ini sesuai dengan lokasi aksi logout Anda

const store = createStore(authreducers); // redux api for get store without using connect

// Helper function to validate the token
const isTokenExpired = () => {
  const expireIn = localStorage.getItem("expireIn");
  if (!expireIn) return true;

  const exptime = new Date(expireIn);
  const now = new Date();

  return now.getTime() > exptime.getTime();
};

// Validate token and dispatch logout if expired
const validateToken = () => {
  if (isTokenExpired()) {
    store.dispatch(logout());
    throw new Error("Token telah kedaluwarsa");
  }
};

// Function to get and decode token
export const getToken = () => {
  validateToken(); // Ensure the token is valid

  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Token tidak ditemukan");
  }

  const company = localStorage.getItem("company");

  let JWT_DECODE;
  try {
    JWT_DECODE = jwt.verify(token, process.env.REACT_APP_TOKEN_KEY);
  } catch (error) {
    console.error("Error decoding token:", error.message);
    store.dispatch(logout()); // Optionally log out if token is invalid
    throw new Error("Token tidak valid");
  }

  const COMPANY = company ? JSON.parse(company) : {};

  return {
    token : token,
    userId: JWT_DECODE.userId,
    nameUser: JWT_DECODE.nameUser,
    name_company: JWT_DECODE.name_company,
    companyId: JWT_DECODE.companyId,
    branchId: COMPANY.branch || null,
    createdBy: `${JWT_DECODE.nameUser} (${JWT_DECODE.userId})`,
    updatedBy: `${JWT_DECODE.nameUser} (${JWT_DECODE.userId})`,
  };
};

export const getUserData = () => {
  try {
    return getToken();
  } catch (error) {
    console.error(error.message);
    return null;
  }
};

// Helper function to configure fetch requests
export const configFetch = (
  url,
  method,
  body,
  isJSON = false,
  extraHeaders = {}
) => ({
  method,
  url,
  data: isJSON ? body : querystring.stringify(body),
  headers: {
    "Content-Type": isJSON
      ? "application/json"
      : "application/x-www-form-urlencoded",
    Accept: "application/json",
    ...extraHeaders,
  },
});
